"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountrySelect = void 0;
const React = __importStar(require("react"));
const country_code_lookup_1 = require("country-code-lookup");
const merlin_select_1 = require("@travelnest/merlin.select");
const sortedCountries = country_code_lookup_1.countries.sort((a, b) => a.country > b.country ? 1 : -1);
const CountrySelect = ({ id, onChange, placeholder, valid, value, excludedCountries }) => {
    const onSelectionChange = (e) => {
        const selected = e.target.value;
        if (placeholder !== undefined && selected === '__placeholder') {
            onChange(undefined);
        }
        else {
            onChange(e.target.value);
        }
    };
    const filteredCountries = excludedCountries ? sortedCountries.filter((item) => !excludedCountries.includes(item.iso2)) : sortedCountries;
    return React.createElement(React.Fragment, null,
        React.createElement(merlin_select_1.Select, { id: id || 'country-select', onChange: onSelectionChange, valid: valid, value: value !== null && value !== void 0 ? value : '__placeholder' },
            placeholder !== undefined && React.createElement("option", { key: "placeholder", value: "__placeholder" }, placeholder),
            filteredCountries.map((c, i) => React.createElement("option", { key: i, value: c.iso2 }, c.country))));
};
exports.CountrySelect = CountrySelect;
//# sourceMappingURL=CountrySelect.js.map